import React from 'react'
import RootItem from './RootItem.jsx'
import GroupItem from './GroupItem.jsx'
import AttributeItem from './AttributeItem.jsx'

export default {
  
  createTreeItem( node, props ) {
    if ( node == null ) {
      return null;
    }
    switch ( node.type ) {
      case 'root': return <RootItem {...props} />;// return new RootItem( props );
      case 'group': return <GroupItem {...props} />;// return new GroupItem( props );
      case 'attribute': return <AttributeItem {...props} />;// return new AttributeItem( props );
      default: return null
    }
  }

}
